module.exports = __webpack_public_path__ + "media/images/flags/sc-9ba013463b785efeb6be8cb92d335bb1.svg";